import GenericTable from "components/CRPComponents/Tables/GenericTable";
import Create from "./Create";
import Update from "./Update";

export const GenericMethods = {
  List: GenericTable,
  Create,
  Update,
};
